'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, useState } from 'react';
import AnimatedButton from '@/components/shared/AnimatedButton';
import EmailButton from '@/components/shared/Footer/EmailButton';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import cn from '@/helpers/cn';
import PlusMinusIcon from './PlusMinusIcon';
import css from './style.module.scss';
import { JoinTeamDto } from './types';
interface Props {
  data: JoinTeamDto;
}
const JoinTeam: FC<Props> = t0 => {
  const $ = _c(27);
  const {
    data
  } = t0;
  const [activeIndex, setActiveIndex] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = index => {
      setActiveIndex(prev => prev === index ? null : index);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleAccordion = t1;
  let t2;
  if ($[1] !== data.title) {
    t2 = <Typography uppercase={true} variant="h2" tag="h2" className={css.title}><StrapiRichContent content={data.title} /></Typography>;
    $[1] = data.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.description) {
    t3 = <p>{data.description}</p>;
    $[3] = data.description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    t5 = <EmailButton isAccent={true} className={css.emailButton} text="serhii.denysenko@theqream.com" size="small" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== data.emailPrependText) {
    t6 = <p>{data.emailPrependText} {t4}{t5}</p>;
    $[7] = data.emailPrependText;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <Typography variant="body-m" tag="div" className={css.text}>{t3}{t6}</Typography>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <div className={css.leftSide}>{t2}{t7}</div>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeIndex || $[16] !== data.applyBtnText || $[17] !== data.positions) {
    let t10;
    if ($[19] !== activeIndex || $[20] !== data.applyBtnText) {
      t10 = (position, index_0) => <div key={index_0} className={cn(css.accordeon, activeIndex === index_0 ? css.opened : "")}><button className={css.activator} onClick={() => toggleAccordion(index_0)}><Typography uppercase={true} variant="h4" tag="h3" className={css.activatorTitle}>{position.title}</Typography><PlusMinusIcon isMinus={activeIndex === index_0} /></button><div className={css.content}><div className={css.inner}><Typography variant="body-m" tag="div" className={css.details}><StrapiRichContent content={position.details} /></Typography><AnimatedButton type="link" href="mailto:serhii.denysenko@theqream.com" className={css.applyBtn}>{data.applyBtnText}</AnimatedButton></div></div></div>;
      $[19] = activeIndex;
      $[20] = data.applyBtnText;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    t9 = data.positions.map(t10);
    $[15] = activeIndex;
    $[16] = data.applyBtnText;
    $[17] = data.positions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div className={css.rightSide}>{t9}</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <section id="join-team-section" className={css.wrapper}><div className={css.container}>{t8}{t10}</div></section>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default JoinTeam;